import { z } from 'zod';
/**
 * Query-string booleans. `z.coerce.boolean()` runs `Boolean(value)`, so the
 * literal string "false" became `true`, which silently inverted a filter the
 * moment a client sent `?reopened=false`. Only the explicit tokens below are
 * accepted; an empty string still means `false` (existing behaviour); any
 * other value is a 400 rather than a guess.
 */
export const queryBoolean = z.preprocess((v) => {
    if (typeof v === 'boolean' || v === undefined)
        return v;
    if (typeof v === 'string') {
        const t = v.trim().toLowerCase();
        if (t === 'true' || t === '1')
            return true;
        if (t === 'false' || t === '0' || t === '')
            return false;
    }
    return v;
}, z.boolean());
//# sourceMappingURL=query-params.js.map